'use strict';

angular.module('app').directive('angularLeafletMap', function(GTM, $timeout) {
    return {
        restrict: 'C',
        link: function(scope, element, attrs) {
          var doc = $(document);

          doc.ready(function(){
            $timeout(function(){
              $('.leaflet-control-zoom-in').click(function (argument) {
                GTM.event('map_zoom_in');
              });

              $('.leaflet-control-zoom-out').click(function (argument) {
                GTM.event('map_zoom_out');
              });
            },300)

            doc.on('click','.leaflet-popup-content',function(){
                GTM.event('map_tooltip_click');
            });
          })

        }
    };
});
